export default __webpack_public_path__ + "static/crm-features-list-1--18f7f41df69c845f2360468e7b42596e.png";